/* eslint-disable */
// src/services/advisoryPublicService.js

import { collection, getDocs, query, orderBy, limit as qlimit } from "firebase/firestore";
import { db } from "./firebase";

const COL = "advisory_centers"; // ✅ 관리자 컬렉션명에 맞춰 수정

export async function listAdvisoryPublic(opts = {}) {
    const n = Number(opts?.limit);
    const lim = Number.isFinite(n) && n > 0 ? Math.min(n, 500) : 200;

    const colRef = collection(db, COL);
    const q = query(colRef, orderBy("updatedAt", "desc"), qlimit(lim));
    const snap = await getDocs(q);

    const rows = [];
    snap.forEach((d) => {
        rows.push({ id: d.id, ...(d.data() || {}) });
    });

    return rows;
}
